/**
 * The single place the frontend reads build-time configuration.
 *
 * WHY CENTRALISE IT
 *  1. `import.meta.env` is inlined by Vite at build time and is a syntax error
 *     under Jest's CommonJS transform. Confining it to one module lets tests
 *     substitute a stub (see jest.config.cjs `moduleNameMapper`) instead of
 *     every consumer needing a mock.
 *  2. Values are parsed and defaulted once, so a malformed number cannot mean
 *     something different in two different components.
 *
 * Only `VITE_`-prefixed variables exist in the bundle, and every one of them is
 * public — never put a secret here.
 */

function num(value: string | undefined, fallback: number): number {
  const parsed = Number(value);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : fallback;
}

export const ENV = {
  supabaseUrl: import.meta.env.VITE_SUPABASE_URL ?? '',
  supabaseAnonKey: import.meta.env.VITE_SUPABASE_ANON_KEY ?? '',
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL ?? 'http://localhost:4000',
  /** Idle period before the session is ended. Default 30 minutes. */
  inactivityTimeoutMs: num(import.meta.env.VITE_INACTIVITY_TIMEOUT_MS, 30 * 60 * 1000),
  /** How often shared-data views re-poll for other users' edits. Default 15 s. */
  sharedPollIntervalMs: num(import.meta.env.VITE_SHARED_POLL_INTERVAL_MS, 15_000),
} as const;
